<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/13oz3uK/tc-custom/9781684121458.jpg?1705766049217" alt="This image is the cover for the book Funniest & Grossest Joke Book Ever!"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Funniest & Grossest Joke Book Ever!
      </h1>
      <p class="bookDescription body article font2">
        <b>Make your friends giggle, guffaw, and groan with disgust at over 900 jokes in this massive volume that combines two hilarious books in one.</b><br/>  <br/> It’s a 2-for-1 of epic proportions. This book combines our two bestselling kids’ joke books: <i>The Funniest Joke Book Ever!</i> and <i>The Grossest Joke Book Ever!</i> Do you know a kid who likes Q&amp;A jokes, knock-knocks, puns, riddles, or one-liners? Of course you do! This collection has all that and more—over 900 jokes—actually. Perfect for boys or girls, it spans all kid-friendly topics, including fairy tales, animals, monsters, and disgusting jokes that’ll make them (and you) want to barf. They’ll laugh out loud at zingers like:<br/>  <br/> Q: What do you call a cow with a twitch?<br/> A: Beef jerky!<br/>  <br/> Q: Do zombies eat candy with their fingers?<br/> A: No, they eat the fingers separately.<br/>  <br/> Q: What kind of life was found on Pluto?<br/> A: Fleas!<br/>  <br/> And many more!
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Editors of Portable Press
      </h2>
      
      <p class="authorDescription body article">Portable Press is a tight-knit group of writers, researchers, and editors who are responsible for some of the publishing industry&rsquo;s most popular non-fiction trivia and facts books. Aside from creating the fan-favorite Uncle John&rsquo;s Bathroom Reader series (more than 16 million books in print since 1988), the Portable Press team also specializes in regional and kids&rsquo; titles, plus gift books, activity books, and whatever else strikes their fancy.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Portable Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?860eb958